// Autosave status state machine for the compose indicator (mirrors surveys).

export type SaveStatus = 'idle' | 'dirty' | 'saving' | 'saved' | 'error';

export function computeSaveStatus(input: {
  saving: boolean;
  isDirty: boolean;
  error: boolean;
  hasSavedOnce: boolean;
}): SaveStatus {
  if (input.error) return 'error';
  if (input.saving) return 'saving';
  if (input.isDirty) return 'dirty';
  return input.hasSavedOnce ? 'saved' : 'idle';
}

export const SAVE_STATUS_LABEL: Record<SaveStatus, string> = {
  idle: '',
  dirty: 'Unsaved changes…',
  saving: 'Saving…',
  saved: 'All changes saved',
  error: "Couldn't save — retrying",
};
